import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS_CONST } from '../../helpers/styles';

interface Props {
  top: number;
  title: string;
  handlerClick(): void;
  isSelected: boolean;
}

export const BoxTab: FC<Props> = ({ top, title, isSelected, handlerClick }) => {
  const isBorder = isSelected ? `${COLORS_CONST.blue} 6px double` : 'none';
  return (
    <Box
      onClick={handlerClick}
      position="absolute"
      width="36px"
      height="100px"
      left="-36px"
      top={`${top}px`}
      bgcolor={COLORS_CONST.basic}
      color="#fff"
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      borderLeft={isBorder}
      borderTop={isBorder}
      borderBottom={isBorder}
      sx={{
        borderTopLeftRadius: '6px',
        borderBottomLeftRadius: '8px',
        cursor: 'pointer',
        boxSizing: 'border-box',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          transform: 'rotate(-90deg)',
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};
